export const ticketRoutes = [
  {
    path: '/student-tickets',
    component: () => import('@/views/studentTicket/StudentTicketPage.vue'),
    name: 'StudentTicket',
    meta: {
      title: 'Hỗ trợ',
      auth: true,
      permission: 'view-student-ticket'
    }
  },
  {
    path: '/student-tickets/:id',
    component: () => import('@/views/studentTicket/StuTicketDetailPage.vue'),
    name: 'StudentTicket',
    meta: {
      title: 'Hỗ trợ',
      auth: true,
      permission: 'view-student-ticket'
    }
  }
]
